(ns hypnos.consumer.panels.error
  "Error panel for the consumer application."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Panel

(defn panel
  "The error panel"
  []
  (let [_error (rf/subscribe [:consumer/error])]
    [:div.hero-body
     [:div.container
      [:div.columns.is-centered
       [:div.column.is-two-fifths
        [:div.has-text-centered
         [:div
          [:div.has-text-centered
           [:div.error-page-icon
            [:span.icon [:i.mdi.mdi-alert-circle.default]]]
           [:div.error-page-caption
            [:h2 (tr :ui.error/page-not-found-title)]]
           [:div.error-page-action
            [:article.message
             [:div.message-body
              [:p (tr :ui.error/page-not-found-message)]]]]]]]]]]]))
